// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import Inter font */

/* Reset and base styles */
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    line-height: 1.6;
    color: #0F172A;
    background: #F8FAFC;
    font-weight: 400;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 24px;
}

/* Landing Page */
.landing-page {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

/* Header */
.landing-header {
    position: sticky;
    top: 0;
    z-index: 50;
    background: #FFFFFF;
    border-bottom: 1px solid #E2E8F0;
    padding: 20px 0;
}

.header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.logo {
    display: flex;
    align-items: center;
    gap: 12px;
    text-decoration: none;
}

.logo-icon {
    width: 36px;
    height: 36px;
    background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
}

.logo-text {
    font-size: 22px;
    font-weight: 700;
    color: #0F172A;
    letter-spacing: -0.5px;
}

.logo-text-accent {
    color: #2563eb;
    font-weight: 800;
}

.admin-login-btn {
    background: #2563eb;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 6px;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.admin-login-btn:hover {
    background: #1d4ed8;
    transform: translateY(-1px);
}

/* Main Content */
.main-content {
    flex: 1 1;
    display: flex;
    align-items: center;
    padding: 40px 0;
    background: #FFFFFF;
}

.content-wrapper {
    width: 100%;
}

/* Role Section */
.role-section {
    width: 100%;
}

.section-header {
    text-align: center;
    margin-bottom: 60px;
}

.section-title {
    font-size: 32px;
    font-weight: 700;
    color: #0F172A;
    margin-bottom: 12px;
    letter-spacing: -0.5px;
}

.section-subtitle {
    font-size: 18px;
    color: #64748B;
    font-weight: 400;
    line-height: 1.6;
}

.role-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    max-width: 1100px;
    margin: 0 auto;
}

/* Responsive */
@media (max-width: 1024px) {
    .role-grid {
        grid-template-columns: repeat(2, 1fr);
        max-width: 700px;
    }

    .section-title {
        font-size: 28px;
    }
}

@media (max-width: 768px) {
    .container {
        padding: 0 20px;
    }

    .section-title {
        font-size: 26px;
    }

    .section-subtitle {
        font-size: 16px;
    }

    .role-grid {
        grid-template-columns: 1fr;
        max-width: 400px;
        gap: 20px;
    }

    .main-content {
        padding: 30px 0;
    }
}

@media (max-width: 480px) {
    .container {
        padding: 0 16px;
    }

    .landing-header {
        padding: 16px 0;
    }

    .logo-text {
        font-size: 20px;
    }

    .admin-login-btn {
        padding: 8px 16px;
        font-size: 14px;
    }

    .section-title {
        font-size: 24px;
        margin-bottom: 8px;
    }

    .section-subtitle {
        font-size: 15px;
    }

    .role-grid {
        gap: 16px;
    }
}

/* =========================================
   CUSTOM REGISTRATION SUCCESS POPUP STYLES
   ========================================= */

.success-popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(15, 23, 42, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    backdrop-filter: blur(4px);
    animation: fadeInOverlay 0.3s ease-out forwards;
}

.success-popup-card {
    background: #ffffff;
    padding: 40px 30px;
    border-radius: 20px;
    width: 90%;
    max-width: 450px;
    text-align: center;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    animation: popInCard 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
}

.success-popup-icon {
    width: 80px;
    height: 80px;
    background: #ecfdf5;
    color: #10b981;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 20px;
    box-shadow: 0 4px 14px rgba(16, 185, 129, 0.2);
}

.success-popup-card h3 {
    color: #0f172a;
    font-size: 26px;
    margin-bottom: 10px;
    font-weight: 800;
    letter-spacing: -0.5px;
}

.success-popup-card p {
    color: #64748b;
    font-size: 16px;
    margin-bottom: 24px;
}

.approval-text-box {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    padding: 16px;
    border-radius: 12px;
}

.approval-text-box p {
    margin-bottom: 8px;
    font-size: 15px;
    color: #334155;
}

.approval-text-box p:last-child {
    margin-bottom: 0;
}

.contact-admin-text {
    color: #2563eb !important;
}

@keyframes fadeInOverlay {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

@keyframes popInCard {
    0% {
        transform: scale(0.9);
        opacity: 0;
    }

    100% {
        transform: scale(1);
        opacity: 1;
    }
}

@media (max-width: 480px) {
    .success-popup-card {
        padding: 30px 20px;
    }

    .success-popup-card h3 {
        font-size: 22px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/public/LandingPage.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAGtB,0BAA0B;AAC1B;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,uFAAuF;IACvF,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA,iBAAiB;AACjB;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA,WAAW;AACX;IACI,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,6DAA6D;IAC7D,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA,iBAAiB;AACjB;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA,iBAAiB;AACjB;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,iBAAiB;IACjB,cAAc;AAClB;;AAEA,eAAe;AACf;IACI;QACI,qCAAqC;QACrC,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;QAC1B,gBAAgB;QAChB,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;AACJ;;AAEA;;8CAE8C;;AAE9C;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,0BAA0B;IAC1B,+CAA+C;AACnD;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,iDAAiD;IACjD,0EAA0E;AAC9E;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,8CAA8C;AAClD;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,UAAU;IACd;;IAEA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* Import Inter font */\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');\n\n/* Reset and base styles */\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\nbody {\n    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n    line-height: 1.6;\n    color: #0F172A;\n    background: #F8FAFC;\n    font-weight: 400;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n.container {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 0 24px;\n}\n\n/* Landing Page */\n.landing-page {\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n}\n\n/* Header */\n.landing-header {\n    position: sticky;\n    top: 0;\n    z-index: 50;\n    background: #FFFFFF;\n    border-bottom: 1px solid #E2E8F0;\n    padding: 20px 0;\n}\n\n.header-content {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.logo {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    text-decoration: none;\n}\n\n.logo-icon {\n    width: 36px;\n    height: 36px;\n    background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n}\n\n.logo-text {\n    font-size: 22px;\n    font-weight: 700;\n    color: #0F172A;\n    letter-spacing: -0.5px;\n}\n\n.logo-text-accent {\n    color: #2563eb;\n    font-weight: 800;\n}\n\n.admin-login-btn {\n    background: #2563eb;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 6px;\n    font-size: 15px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.admin-login-btn:hover {\n    background: #1d4ed8;\n    transform: translateY(-1px);\n}\n\n/* Main Content */\n.main-content {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    padding: 40px 0;\n    background: #FFFFFF;\n}\n\n.content-wrapper {\n    width: 100%;\n}\n\n/* Role Section */\n.role-section {\n    width: 100%;\n}\n\n.section-header {\n    text-align: center;\n    margin-bottom: 60px;\n}\n\n.section-title {\n    font-size: 32px;\n    font-weight: 700;\n    color: #0F172A;\n    margin-bottom: 12px;\n    letter-spacing: -0.5px;\n}\n\n.section-subtitle {\n    font-size: 18px;\n    color: #64748B;\n    font-weight: 400;\n    line-height: 1.6;\n}\n\n.role-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 24px;\n    max-width: 1100px;\n    margin: 0 auto;\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n    .role-grid {\n        grid-template-columns: repeat(2, 1fr);\n        max-width: 700px;\n    }\n\n    .section-title {\n        font-size: 28px;\n    }\n}\n\n@media (max-width: 768px) {\n    .container {\n        padding: 0 20px;\n    }\n\n    .section-title {\n        font-size: 26px;\n    }\n\n    .section-subtitle {\n        font-size: 16px;\n    }\n\n    .role-grid {\n        grid-template-columns: 1fr;\n        max-width: 400px;\n        gap: 20px;\n    }\n\n    .main-content {\n        padding: 30px 0;\n    }\n}\n\n@media (max-width: 480px) {\n    .container {\n        padding: 0 16px;\n    }\n\n    .landing-header {\n        padding: 16px 0;\n    }\n\n    .logo-text {\n        font-size: 20px;\n    }\n\n    .admin-login-btn {\n        padding: 8px 16px;\n        font-size: 14px;\n    }\n\n    .section-title {\n        font-size: 24px;\n        margin-bottom: 8px;\n    }\n\n    .section-subtitle {\n        font-size: 15px;\n    }\n\n    .role-grid {\n        gap: 16px;\n    }\n}\n\n/* =========================================\n   CUSTOM REGISTRATION SUCCESS POPUP STYLES\n   ========================================= */\n\n.success-popup-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(15, 23, 42, 0.6);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    backdrop-filter: blur(4px);\n    animation: fadeInOverlay 0.3s ease-out forwards;\n}\n\n.success-popup-card {\n    background: #ffffff;\n    padding: 40px 30px;\n    border-radius: 20px;\n    width: 90%;\n    max-width: 450px;\n    text-align: center;\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n    animation: popInCard 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;\n}\n\n.success-popup-icon {\n    width: 80px;\n    height: 80px;\n    background: #ecfdf5;\n    color: #10b981;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto 20px;\n    box-shadow: 0 4px 14px rgba(16, 185, 129, 0.2);\n}\n\n.success-popup-card h3 {\n    color: #0f172a;\n    font-size: 26px;\n    margin-bottom: 10px;\n    font-weight: 800;\n    letter-spacing: -0.5px;\n}\n\n.success-popup-card p {\n    color: #64748b;\n    font-size: 16px;\n    margin-bottom: 24px;\n}\n\n.approval-text-box {\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    padding: 16px;\n    border-radius: 12px;\n}\n\n.approval-text-box p {\n    margin-bottom: 8px;\n    font-size: 15px;\n    color: #334155;\n}\n\n.approval-text-box p:last-child {\n    margin-bottom: 0;\n}\n\n.contact-admin-text {\n    color: #2563eb !important;\n}\n\n@keyframes fadeInOverlay {\n    0% {\n        opacity: 0;\n    }\n\n    100% {\n        opacity: 1;\n    }\n}\n\n@keyframes popInCard {\n    0% {\n        transform: scale(0.9);\n        opacity: 0;\n    }\n\n    100% {\n        transform: scale(1);\n        opacity: 1;\n    }\n}\n\n@media (max-width: 480px) {\n    .success-popup-card {\n        padding: 30px 20px;\n    }\n\n    .success-popup-card h3 {\n        font-size: 22px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
